import type { Sep10ChallengeResponse } from "@/utils/types";

export async function issueSep10LinkChallenge(payload: {
  network: "PUBLIC" | "TESTNET";
  address: string;
}): Promise<Sep10ChallengeResponse> {
  const res = await fetch("/api/auth/stellar/link/issue", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const errorText = await res.text().catch(() => "unknown_error");
    throw new Error(`Failed to issue SEP-10 challenge (${String(res.status)}): ${errorText}`);
  }

  return (await res.json()) as Sep10ChallengeResponse;
}

export async function verifySep10Link(payload: {
  challengeId: string;
  address: string;
  txXDR: string;
}): Promise<{ success: boolean }> {
  const res = await fetch("/api/auth/stellar/link/verify", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const errorText = await res.text().catch(() => "unknown_error");
    throw new Error(`Failed to verify SEP-10 challenge (${String(res.status)}): ${errorText}`);
  }

  return (await res.json()) as { success: boolean };
}
